import React, { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Stack,
  MenuItem,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Tooltip,
  Checkbox,
} from "@mui/material";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";
import { useStyles } from "./styles";
import { useNavigate } from "react-router-dom";
import useCircular from "../../../Hooks/circular";
import Loader from "../../../common/Loader";
import usePagination from "../../../common/usePagination";
import CustomPagination from "../../../common/Pagination";
import { scrolltoView } from "../../../Utils/scrollToView";
import DropZone from "../../../common/DropZone";
import useCourse from "../../../Hooks/course";
import useAuthStore from "../../../Hooks/auth";
import { setRedirect } from "../../../store/assignment";
import ToggleSwitch from "../../../common/ToggleSwitch";
import { getStatusInBoolen, getToggleStatus } from "../../../Utils/deleteutils";
import { yearList } from "../../StaffScreen/Migration/fillter";

const columns = [
  {
    id: "S.No",
    label: "S.No",
    align: "center",
    sortby: true,
  },
  {
    id: "date",
    label: "Date",
    align: "center",
    sortby: true,
  },
  {
    id: "title",
    label: "Circular Title",
    align: "center",
    sortby: true,
  },
  {
    id: "department",
    label: "Department",
    align: "center",
    sortby: true,
  },
  {
    id: "year",
    label: "Year",
    align: "center",
    sortby: true,
  },
  {
    id: "edit",
    label: "Edit",
    align: "center",
  },
  {
    id: "delete",
    label: "Actions",
    align: "center",
  },
];

const CircularSchema = Yup.object().shape({
  title: Yup.string().required("* Please enter title"),
  description: Yup.string().required("* Please enter the circular description"),
  idTarget: Yup.string().required("*Please select the target audience"),
});

const CircularList = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    getAllCircularAction,
    circularDate,
    deleteCircularAction,
    addCircularAction,
    setActiveCircularAction,
    loading,
    redirect,
    setRidirectAction,
    setPerPageAction,
    perPage,
    setPageAction,
    setOffsetAction,
    page,
    offset,
    studentsByIdAction,
    getStudentsID,
  } = useCircular();
  const {
    getDepartmentAction,
    departmentData,
  } = useCourse();

  const [file, setFile] = useState(null);
  const [mediaURL, setMediaURL] = useState("");
  const { institutionId } = useAuthStore();
  const [state, setState] = useState([]);
  const [idStudent, setIdStudent] = useState({ studentIDS: [] });
  const [studentName, setStudentName] = useState([]);
  const [idDepartment, setIdDepartment] = useState("");
  const [idYear, setIdYear] = useState("");
  const [formErrors, setFormErrors] = useState({});
  // console.log("mediaURL", mediaURL, file);

  const handlePage = (e) => {
    setPerPageAction(e.target.value);
    setOffsetAction(0)
    setPageAction(1)
  };

  const count =
    circularDate && Math.ceil(circularDate?.totalNoOfRecords?.totalNoOfRecords / perPage);
  const _DATA = usePagination(circularDate, perPage);
   

  const handleChange = useCallback(
    (e, p) => {
      setPageAction(p);
      setOffsetAction(p * perPage - perPage);
      _DATA.jump(p);
    },
    [perPage, page]
  );

  React.useEffect(() => {
    getDepartmentAction({
      department: {
        institutionId,
      },
    });
  }, []);

  React.useEffect(() => {
    if (redirect === true) {
      scrolltoView(`#circlarList`);
    }
    return () => {
      setRidirectAction();
    };
  }, [redirect]);

  React.useEffect(() => {
    getAllCircularAction({
      limit: perPage,
      offset: offset,
      institutionId,
    });
  }, [perPage, offset]);

  const initValues = {
    title: "",
    description: "",
  };

  const editList = (id) => {
    setActiveCircularAction(id);
    navigate("/circularManagement/edit", { state: { id: id } });
    // scrolltoView("circlarList")
  };


  const handleChangeFile = (file) => {
    const _file = file[0];
    if (_file) {
      setFile(_file);
      let reader = new FileReader();
      // Convert the file to base64 text
      reader.readAsDataURL(_file);
      reader.onload = () => {
        setMediaURL(reader.result.substr(reader.result.indexOf(",") + 1));
      };
    }
  };

  const handleSelectStudentFocus = (event) => {
    const {
      target: { value },
    } = event;
    setState(
      // On autofill we get a stringified value.
      typeof value === "string" ? value?.split(",") : value
    );
  };

  const handleStudentSelectAll = (event) => {
    if (event.target.checked) {
      let customer_names = getStudentsID?.map((ele) => ele?.name)
      let selectCustomer_id = [];
      getStudentsID?.map((ele) => {
        selectCustomer_id?.push({ id: ele?.id })
      })
      setStudentName(customer_names)
      setIdStudent({ studentIDS: selectCustomer_id })
    }
    else {
      setStudentName([])
      setIdStudent({ studentIDS: [] })
    }
  }

  const handleSelectStudent = (event, data) => {
    if (idStudent?.studentIDS?.some((item) => item?.id == data?.id)) {
      setIdStudent({ ...idStudent, studentIDS: idStudent?.studentIDS?.filter((item) => item?.id !== data?.id) })
    } else {
      setIdStudent({ ...idStudent, studentIDS: [...idStudent?.studentIDS, { id: data?.id }] })
    }
    if (studentName?.includes(data.name)) {
      setStudentName(studentName?.filter((item) => item !== data?.name))
    } else {
      setStudentName([...studentName, data?.name])
    }
  };

  useEffect(() => {
    if (idYear && idDepartment) {
      studentsByIdAction({
        currentYear: idYear,
        DepartmentID: idDepartment,
        institutionId: institutionId
      })
      setStudentName([]);
      setIdStudent({ studentIDS: [] });
    }
  }, [idYear, idDepartment])


  const handleAddSubmit = (values, resetForm) => {
    const errors = {};
    if (studentName?.length === 0) {
      errors.studentName = "* Please select the student"
    }
    if (idDepartment === "") {
      errors.idDepartment = "* Please select the department"
    }
    if (idYear === "") {
      errors.idYear = "* Please select the year"
    }
    if (!values.description) {
      errors.description = "* Please enter the circular description"
    }
    if (!values.title) {
      errors.title = "* Please enter title"
    }
    setFormErrors(errors)

    if (Object.keys(errors).length === 0) {
      addCircularAction({
        // ...values,
        // ...additionalInfo,
        institutionId,
        fileName: file?.name,
        contentType: file?.name?.split(".")[file?.name?.split(".").length - 1],
        mediaUrl: mediaURL,
        idStudents: idStudent.studentIDS,
        idDepartment: idDepartment,
        currentYear: idYear,
        title: values.title,
        description: values.description
      });
      scrolltoView(`#circlarList`);
      resetForm();
      setMediaURL("");
      setIdStudent({ studentIDS: [] });
      setStudentName([]);
      setIdDepartment("");
      setIdYear("")
      setFile(null);
    }
  }
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };
  return (
    <>
      {loading && <Loader />}
      <Grid container className={classes.circularList}>
        <Grid item lg={8} xs={12}>
          <Stack className={classes.align}>
            <Formik
              // validationSchema={CircularSchema}
              initialValues={initValues}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={(values, { resetForm }) => {
                handleAddSubmit(values, resetForm);
              }}
            >
              {(formik) => {
                const {
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  values,
                } = formik;
                return (
                  <form onSubmit={handleSubmit}>
                    <Stack>
                      <Typography className={classes.title} sx={{ pb: 2 }}>
                        Add Circular
                      </Typography>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Title
                      </Typography>
                      <TextField
                        id="title"
                        name="title"
                        placeholder="Enter Title"
                        className={
                          errors.title && touched.title
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        onChange={handleChange}
                        value={values.title}
                      />
                      <span className={classes.error}>
                        {formErrors.title}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Circular Description
                      </Typography>
                      <TextField
                        id="description"
                        name="description"
                        placeholder="Enter Circular Description"
                        multiline
                        rows={4}
                        className={
                          errors.description && touched.description
                            ? classes.inputError
                            : classes.inputNoError
                        }
                        type="text"
                        onChange={handleChange}
                        value={values.description}
                      />
                      <span className={classes.error}>
                        {formErrors.description}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Department
                      </Typography>
                      <Select
                        id="idDepartment"
                        name="idDepartment"
                        placeholder="Choose Organization"
                        IconComponent={CustomExpandMore}
                        defaultValue="Select Department"
                        onChange={(e) => {
                          handleChange(e);
                          setIdDepartment(e.target.value)
                        }}
                        value={idDepartment}
                        displayEmpty
                        sx={{
                          "& .MuiSelect-select .notranslate::after":
                            "Select a filter"
                              ? { content: `"Select Department"`, opacity: 1 }
                              : {},
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Department
                        </MenuItem>
                        {departmentData && departmentData?.map(
                          (_el, index) => (
                            <MenuItem value={_el.id} key={index}> {_el.name}</MenuItem>
                          ))}
                      </Select>
                      <span className={classes.error}>
                        {formErrors.idDepartment}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Year
                      </Typography>
                      <Select
                        id="idYear"
                        name="idYear"
                        placeholder="Choose Organization"
                        IconComponent={CustomExpandMore}
                        defaultValue="Select Year"
                        onChange={(e) => {
                          handleChange(e);
                          setIdYear(e.target.value)
                        }}
                        value={idYear}
                        displayEmpty
                        sx={{
                          "& .MuiSelect-select .notranslate::after":
                            "Select a filter"
                              ? { content: `"Select Year"`, opacity: 1 }
                              : {},
                        }}
                      >
                        <MenuItem value="" disabled>
                          Select Year
                        </MenuItem>
                        {yearList && yearList?.map((_el, index) => (
                          <MenuItem value={_el.value} key={index}> {_el.label} </MenuItem>
                        ))}
                      </Select>
                      <span className={classes.error}>
                        {formErrors.idYear}
                      </span>
                    </Stack>
                    <Stack sx={{ pb: 3 }}>
                      <Typography
                        sx={{ pb: 1 }}
                        className={classes.input_label}
                      >
                        Student
                      </Typography>
                      <Select
                        disabled={idYear === "" || idDepartment === "" ? true : false}
                        id="studentName"
                        name="studentName"
                        multiple
                        placeholder="Choose Organization"
                        IconComponent={CustomExpandMore}
                        defaultValue="Select Student"
                        displayEmpty
                        value={studentName}
                        onFocus={handleSelectStudentFocus}
                        renderValue={(selected) => selected?.join(', ')}
                        sx={{
                          "& .MuiSelect-select .notranslate::after":
                            "Select a filter"
                              ? { content: `"Select Student"`, opacity: 1 }
                              : {},
                        }}
                      >
                        <MenuItem value="" disabled>Select Student</MenuItem>
                        {getStudentsID?.length > 1 ?
                          <label htmlFor="studentAll">
                            <div style={{ padding: "6px 16px", cursor: "pointer" }} onChange={(event) => handleStudentSelectAll(event)}>
                              <Checkbox id="studentAll" checked={idStudent?.studentIDS?.length === getStudentsID?.length} />Select All
                            </div>
                          </label> : ""}
                        {getStudentsID &&
                          getStudentsID?.map((_el, index) => (
                            <div key={_el?.id} style={{ padding: "6px 16px", cursor: "pointer" }}
                              onClick={(event) => handleSelectStudent(event, _el)}
                            >
                              <Checkbox checked={studentName?.includes(_el?.name)} />{_el?.name}
                            </div>
                          ))}
                      </Select>
                      <span className={classes.error}>
                        {formErrors.studentName}
                      </span>
                    </Stack>
                    <DropZone handleChangeFile={handleChangeFile} />
                    <Stack sx={{ mb: 2 }}>
                      <em style={{ marginBottom: "10px" }}>{file?.name}</em>
                    </Stack>
                    <Button
                      type="submit"
                      sx={{
                        width: "100%",
                        px: 1,
                        py: 2,
                        borderRadius: "50px",
                        fontSize: "15px",
                      }}
                      className={classes.submit_btn}
                    >
                      Add Circular
                    </Button>
                  </form>
                );
              }}
            </Formik>
          </Stack>
        </Grid>
        <Grid item lg={12} xs={12}>
          <Stack sx={{ my: 4 }}>
            <Box sx={{ width: "100%" }}>
              <Paper
                sx={{
                  width: "100%",
                  borderRadius: "20px",
                  filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                  boxShadow: "none",
                }}
              >
                <Stack sx={{ p: 4 }}>
                  <TableContainer id="circlarList" sx={{ maxHeight: "440px" }}>
                    <Table
                      aria-label="sticky table"
                      className={classes.root}
                      style={{ padding: 0 }}
                      stickyHeader
                    >
                      <TableHead>
                        <TableRow classes={{ root: classes.thead }}>
                          {columns.map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              style={{
                                minWidth: column.minWidth,
                                paddingLeft: column.paddingLeft,
                              }}
                              classes={{ root: classes.columnData }}
                            >
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody classes={{ root: classes.tBody }}>
                        {circularDate?.circularList?.length ? (
                          circularDate?.circularList?.map((_el, index) => (
                            <TableRow
                              role="checkbox"
                              tabIndex={-1}
                              key={index}
                            >
                              {columns.map((column) => {
                                return (
                                  <>
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {column?.id === "S.No" ? (
                                        <Stack sx={{ alignItems: "center" }}>
                                            <span>{offset + index + 1}</span>
                                        </Stack>
                                      ) : column?.id === "date" ? (
                                          // new Date(_el?.circularDate).toDateString()
                                          formatDate(_el.circularDate)
                                      ) : column?.id === "title" ? (
                                        _el?.title
                                      ) : column?.id === "department" ? (
                                        _el?.departmentName
                                      ) : column?.id === "year" ? (
                                        _el?.currentYear
                                      ) : column?.id === "edit" ? (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            setRedirect(true);
                                            return editList(_el?.id);
                                          }}
                                        >
                                          <img src={Pen} alt="pen" />
                                        </Stack>
                                      ) : (
                                        <Stack
                                          sx={{
                                            alignItems: "center",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            deleteCircularAction({
                                              id: _el?.id,
                                              status: getToggleStatus(
                                                _el?.status
                                              ),
                                            })
                                          }
                                        >
                                          <ToggleSwitch
                                            defaultChecked
                                            checked={getStatusInBoolen(
                                              _el.status
                                            )}
                                          />
                                        </Stack>
                                      )}
                                    </TableCell>
                                  </>
                                );
                              })}
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={columns?.length}
                              sx={{ borderBottom: "none" }}
                            >
                              <Stack
                                sx={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                No Data
                              </Stack>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {circularDate?.totalNoOfRecords?.totalNoOfRecords > 10 && (
                    <CustomPagination
                      count={count}
                      page={page}
                      onPageChange={handleChange}
                      handlePage={handlePage}
                      perPage={perPage}
                    />
                  )}
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default CircularList;
